// * change this string to any other value to force another reload in the next release
const RELOAD_KEY = "Sept 23 2021 v1.0.57";

const swConfig = {
  onUpdate: (registration: ServiceWorkerRegistration) => {
    // skip waiting to update the service worker,
    // then show the "update" banner which reloads the page to ensure all code is current
    registration.unregister().then(() => {
      const waitingServiceWorker = registration.waiting;
      if (waitingServiceWorker) {
        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });

        // force-reload if the RELOAD_KEY has been changed since last time
        const lastForcedReloadKey = window.localStorage.getItem(
          "lastForcedReloadKey"
        );
        const shouldForceReload = lastForcedReloadKey !== RELOAD_KEY;

        if (
          shouldForceReload ||
          window.localStorage.getItem("shouldAutoUpdate") === "true"
        ) {
          window.localStorage.setItem("lastForcedReloadKey", RELOAD_KEY);
          window.location.reload();
        } else {
          showUpdateIsAvailableBanner(waitingServiceWorker);
        }
      }
    });
  },
};
export default swConfig;

function showUpdateIsAvailableBanner(waitingServiceWorker: any) {
  const updateIsAvailableIndicator = document.querySelector(
    ".updateIsAvailableIndicator"
  );
  if (updateIsAvailableIndicator) {
    updateIsAvailableIndicator.classList.add("show");
  }
}
